import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, ElementRef } from '@angular/core';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'app-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss'],
  imports: [CommonModule, CeIconComponent, OverlayModule, MatTooltipModule],
})
export class FilterTagComponent implements OnInit {
  isOpen = true;
  @Output() custom_click = new EventEmitter<any>();
  @Input() tag: any;
  @Input() alert: boolean = false;

  onRemove() {
    if ('isShow' in this.tag) {
      this.tag.isShow = true;
    }
    this.tag.filter.isShow = true;
    this.custom_click.emit({ action: 'filter_remove', value: this.tag });
  }

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    setTimeout(() => {
      const triggerElement = this.elRef.nativeElement.querySelector('[data-bs-toggle="dropdown"]');
      if (triggerElement) {
        triggerElement.click();
      }
    }, 300);
  }
}
